import { module as modujs } from "modujs";

import { gsap } from "gsap";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: "click",
		};
	}

	init() {}

	open(params) {
		this.el.classList.add("is-active");

		if (this.timeout != undefined) {
			this.timeout.kill();
		}

		if (params.aboveHeader) {
			this.el.classList.add("is-above-header");
		}
	}

	close() {
		this.el.classList.remove("is-active");

		if (this.timeout != undefined) {
			this.timeout.kill();
		}

		this.timeout = gsap.delayedCall(0.3, () => {
			this.el.classList.remove("is-above-header");
		});
	}

	click() {
		document.dispatchEvent(new CustomEvent("overlay:click"));
	}

	destroy() {}
}
